import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import InputV1 from "_+_Portal/components/Genericos/InputV1/InputV1";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import { wsGetMedicoPorMatricula } from "_+_Portal/_-_Autocheckin/context/action/medicoPorMatricula";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { proximoPaso } from "../PagesFun";
import {
  LeftContainer,
  MainContainer,
  MedicoSolicitanteBody,
  MedicoSolicitanteContainer,
  MedicoSolicitanteTitulo,
  ResumenBotones,
  RightContainer,
} from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import Keyboard from "_+_Portal/components/Genericos/Keyboard/Keyboard";
import { getLocalStorage } from "global/utils/safeJsonParse";

const MedicoSolicitante = ({ turnoActual, setLoading }) => {
  // -------------------- Contexto --------------------
  const { toasterDispatch, toasterState } = useContext(GlobalContext);
  const {
    turnosSeleccionadosState,
    medicoPorMatriculaDispatch,
    pasoDispatch,
    rutaDispatch,
    rutaState,
    puntoControlDispatch,
  } = useContext(AutocheckContext);

  // -------------------- Contexto --------------------

  // -------------------- Constantes --------------------
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado[turnoActual];

  const medico = turno?.medico;
  const especialidad = turno?.especialidad;
  let idTerminal = getLocalStorage("idTerminal");

  // -------------------- Constantes --------------------

  const bodyTxt =
    "Ingresá la matrícula del médico que se encuentra en el sello de la orden.";

  const [matriculaMedico, setMatriculaMedico] = useState({
    matricula: "",
  });
  // -------------------- Funciones --------------------

  const ingresarMatricula = (e) => {
    if (e.target.value.length <= 7) {
      setMatriculaMedico({ matricula: e.target.value });
    }
  };

  const handleKeyboardChange = (newValue) => {
    if (newValue.length <= 7) {
      setMatriculaMedico({ matricula: newValue });
    }
  };

  const handleClickVolver = () => {
    setPaso("TurnosDelDia")(pasoDispatch);
  };

  const nextStep = (isCorrect) => {
    if (isCorrect) {
      setPaso("ConfirmarMedicoSolicitante")(pasoDispatch);
    } else {
      errorBusqueda();
    }
  };

  const noEncuentroOrden = () => {
    let ruta = rutaState.ruta.data;
    console.log("[FLUJO] MedicoSolicitante.noEncuentroOrden - ruta original:", [...ruta]);

    ruta = ruta.filter((item) => {
      if (item === "ValidarCobertura") {
        return false;
      } else {
        return true;
      }
    });
    console.log("[FLUJO] MedicoSolicitante.noEncuentroOrden - ruta filtrada (sin ValidarCobertura):", [...ruta]);

    if (ruta.length === 1) {
      const idTipoPuntoControl = 16;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    } else {
      setRuta(proximoPaso(ruta, setPaso, pasoDispatch))(rutaDispatch);
      console.log("[FLUJO] MedicoSolicitante.noEncuentroOrden - ruta despues del shift:", ruta);
    }
  };

  const busquedaMedico = () => {
    setLoading("Cargando ...");
    setPaso("Loading")(pasoDispatch);
    wsGetMedicoPorMatricula(
      matriculaMedico.matricula,
      nextStep
    )(medicoPorMatriculaDispatch);
  };

  const errorBusqueda = () => {
    showToaster(
      {
        texto: "La matricula ingresada es inválida.",
        tipo: "danger",
      },
      "centroArriba"
    )(toasterDispatch);
    setPaso("MedicoSolicitante")(pasoDispatch);
  };

  return (
    <LayoutPasos
      handleClick={handleClickVolver}
      volverTo={"/autocheckin/resumen"}
      type={"no-circle"}
      title={"Medico Solicitante"}
    >
      {toasterState.toaster.show && <ToasterV2 />}
      <CardBlueHeart
        medico={medico ? medico : especialidad}
        turnoTitle={especialidad}
        pasoActual={turnoActual + 1}
        pasoTotal={listTurnosSeleccionado.length}
      />
      <MedicoSolicitanteContainer
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <PasoBar paso={"MedicoSolicitante"} />
        <MainContainer>
          <LeftContainer $idTerminal={idTerminal}>
            <MedicoSolicitanteTitulo>
              <span className={`${idTerminal ? "rb32b" : "rb18m"}`}>Médico Solicitante</span>
            </MedicoSolicitanteTitulo>
            <hr className="ValidaTurno-separador"></hr>
            <MedicoSolicitanteBody>
              <span className={`ValidaTurno-bodytxt ${idTerminal ? "rb24t" : "rb18m"}`}>{bodyTxt}</span>
              <div className="ValidaTurno-row">
                <div className="ValidaTurno-input">
                  <InputV1
                    clase="ValidaTurno-input"
                    placeholderText={"12254"}
                    onChange={ingresarMatricula}
                    inputType="number"
                    value={matriculaMedico.matricula}
                    className={"rb24t inputNonScroll"}
                  />
                </div>
                <ResumenBotones>
                  <button onClick={busquedaMedico}>Buscar Médico</button>
                  {/* <button className="danger" onClick={noEncuentroOrden}>
                    No la encuentro
                  </button> */}
                </ResumenBotones>
              </div>
            </MedicoSolicitanteBody>
          </LeftContainer>

          {idTerminal && (
            <RightContainer>
              <Keyboard
                value={matriculaMedico.matricula}
                onChange={handleKeyboardChange}
                onEnter={busquedaMedico}
                maxLength={8}
                enterText="OK"
                darkMode={true}
              />
            </RightContainer>
          )}
        </MainContainer>
      </MedicoSolicitanteContainer>
    </LayoutPasos>
  );
};

export default MedicoSolicitante;
